module.exports = __webpack_public_path__ + "static/media/farwardArrow.0743f410.svg";